module.exports = __webpack_public_path__ + "static/media/taps.9d8ab60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/taps.png
// module id = 102
// module chunks = 0